module.exports = __webpack_public_path__ + "media/images/bin-94b6475e42c88b75dc331fb6b6744f18.png";